import { request, _urlPartner, _urlPartnerCategories, _urlPartnerOffers, } from "../api";
import {PARTNER_CONSTS} from "../constants";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";

//Partners------------------------------------------------------------
export const GetPartners = () => {
    const requestData = {
        url: _urlPartner,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: PARTNER_CONSTS.GET_PARTNERS,
                    payload: data
                });
            })
    }
};

export const GetPartnerById = (id) => {
    const requestData = {
        url: `${_urlPartner}/${id}`,
        token: true,
        method: "GET",
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: PARTNER_CONSTS.GET_PARTNER_BY_ID,
                    payload: res.data
                })
            })
    }
};

export const CreatePartner = data => {
    const requestData = {
        url: _urlPartner,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                notificationSuccess({
                    description: "Գործընկերը հաջողությամբ ստեղծվեց!"
                })
                history.push('/partners/items')
            })
    }
};

export const UpdatePartnerById = (id, data, ) => {
    const requestData = {
        url: `${_urlPartner}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                notificationSuccess({
                    description: "Գործընկերը հաջողությամբ փոփոխվեց!"
                })
                history.push('/partners/items')
            })
    }
};

export const DeletePartnerById = id => {
    const requestData = {
        url: `${_urlPartner}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: PARTNER_CONSTS.DELETE_PARTNER_BY_ID,
                    payload: id
                });
            })
    }
};


//Categories------------------------------------------------------------
export const GetPartnerCategories = () => {
    const requestData = {
        url: _urlPartnerCategories,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: PARTNER_CONSTS.GET_PARTNER_CATEGORIES,
                    payload: data
                });
            })
    }
};

export const GetPartnerCategoryById = (id) => {
    const requestData = {
        url: `${_urlPartnerCategories}/${id}`,
        token: true,
        method: "GET",
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: PARTNER_CONSTS.GET_PARTNER_CATEGORY_BY_ID,
                    payload: res.data
                })
            })
    }
};

export const CreatePartnerCategory = data => {
    const requestData = {
        url: _urlPartnerCategories,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                notificationSuccess({
                    description: "Կատեգորիան հաջողությամբ ստեղծվեց!"
                })
                history.push('/partners/categories')
            })
    }
};

export const UpdatePartnerCategoryById = (id, data, ) => {
    const requestData = {
        url: `${_urlPartnerCategories}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                notificationSuccess({
                    description: "Կատեգորիան հաջողությամբ փոփոխվեց!"
                })
                history.push('/partners/categories')
            })
    }
};

export const DeletePartnerCategoryById = id => {
    const requestData = {
        url: `${_urlPartnerCategories}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: PARTNER_CONSTS.DELETE_PARTNER_CATEGORY_BY_ID,
                    payload: id
                });
            })
    }
};


//Offers---------------------------------------------------------------
export const GetPartnerOffers = () => {
    const requestData = {
        url: _urlPartnerOffers,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: PARTNER_CONSTS.GET_PARTNER_OFFERS,
                    payload: data
                });
            })
    }
};

export const GetPartnerOfferById = (id) => {
    const requestData = {
        url: `${_urlPartnerOffers}/${id}`,
        token: true,
        method: "GET",
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: PARTNER_CONSTS.GET_PARTNER_OFFER_BY_ID,
                    payload: res.data
                })
            })
    }
};

export const CreatePartnerOffer = data => {
    const requestData = {
        url: _urlPartnerOffers,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                notificationSuccess({
                    description: "Առաջարկը հաջողությամբ ստեղծվեց!"
                })
                history.push('/partners/offers')
            })
    }
};

export const UpdatePartnerOfferById = (id, data, ) => {
    const requestData = {
        url: `${_urlPartnerOffers}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                notificationSuccess({
                    description: "Առաջարկը հաջողությամբ փոփոխվեց!"
                })
                history.push('/partners/offers')
            })
    }
};

export const DeletePartnerOfferById = id => {
    const requestData = {
        url: `${_urlPartnerOffers}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: PARTNER_CONSTS.DELETE_PARTNER_OFFER_BY_ID,
                    payload: id
                });
            })
    }
};
